import { PublicClientApplication } from "@azure/msal-browser";
import { LOCAL_STORAGE } from "../constantes";

export const GRAPH_SCOPES = {
    OPENID: "openid",
    PROFILE: "profile",
    USER_READ: "User.Read",
    MAIL_READ: "Mail.Read"
}

export const GRAPH_REQUESTS = {
    LOGIN: {
        scopes: [
            GRAPH_SCOPES.OPENID,
            GRAPH_SCOPES.PROFILE,
            GRAPH_SCOPES.USER_READ
        ]
    },
    EMAIL: {
        scopes: [
            GRAPH_SCOPES.MAIL_READ
        ]
    },
    system : {
        navigateFrameWail: 0
    }
}

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: process.env.REACT_APP_AUTHORITY,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_LOGOUT_REDIRECT_URI
  },
  cache: {
    cacheLocation: LOCAL_STORAGE
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const getUserAuthenticated = () => {
    const users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null;
    if (users !== null) {
        const user = users.filter(userAux => userAux.isAuthenticated)
        if (user.length > 0) return user[0];
        
    }

    return null;
}

export const getScreenNameAuthenticated = () => {
    const user = getUserAuthenticated();
    if (user && user.info && user.info.Nombres) return  user.info.Nombres.replace(/\s/g, "");

    return '';
}